import React, { Component } from 'react'
import Loading from './Loading'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { getProperty } from '../../helpers/properties'
import EnrolmentNew from './EnrolmentNew'
import EnrolmentEdit from './EnrolmentEdit'
import { getYearsEnrolled, isEligibleToEnrolNow, isEligibleToAcceptOffer, hasSanctions } from '../../helpers/enrolment'
import qs from 'qs'
import Error from '../pages/errors/Error'
import SanctionCard from './SanctionCard'

class EnrolmentsContainer extends Component {

    constructor(props) {
    super(props)

  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {

  }

  render() {
    if (this.props.userRole != 'STUDENT') {
      return null
    }

    if (this.props.loadingUnits || this.props.loadingPersonalDetails) {
      return (
        <section className="tile-container">
          <Loading message="Loading your units..." />
        </section>
      )
    }
    
    if (this.props.isFetchingCourses || this.props.isFetchingCourse) {
      return (
        <section className="tile-container">
          <Loading message="Loading your course information..." />
        </section>
      )
    }

    if (hasSanctions(this.props.personalDetails, this.props.courseId)) {
      return (
        <section className="tile-container">
          <div className="page">
            <div className="row">
              <div className="col-xs-12 col-md-offset-2 col-md-8">
                <SanctionCard sanctions={this.props.personalDetails.studentSanctions} courseId={this.props.courseId} />
              </div>
            </div>
          </div>
        </section>
      )
    }

    if (this.props.units.length > 0 && this.props.enrolmentYears.some(eYear => eYear.toString() === this.props.pageContentsToDisplay.toString()) ) {
      let queryParams = ''
      const querySuccess = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      })

      if (querySuccess.hasOwnProperty('success')) {
        queryParams = '?success=true'
      }

      return <EnrolmentEdit success={true} enrolmentYear={this.props.pageContentsToDisplay.toString()}></EnrolmentEdit>
      // if (pageContentsToDisplay === unitYears.toString()) {
      //   return <Redirect to={`${getConfiguration('baseUrl')}/enrolments/${unitYears[0]}${queryParams}`} />
      // }
    }

    if (this.props.pageContentsToDisplay === "NOW" &&
      !(this.props.loadingUnits || this.props.loadingPersonalDetails) &&
      (isEligibleToEnrolNow(this.props.course, hasSanctions(this.props.personalDetails, this.props.courseId)) || isEligibleToAcceptOffer(this.props.course))
    ) {
      return <EnrolmentNew ></EnrolmentNew>
      //return <Redirect to={`${getConfiguration('baseUrl')}/enrolments/new`} />
    }

    

    return (
      <section className="tile-container">
        <div className="page">
          <div className="row">
            <div className="col-xs-12 col-md-offset-2 col-md-8">
              <section className="tile-container">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="empty-state-container  empty-state-container--default">
                      <div className="icon" />
                      <h2>You have not enrolled into any units for this course yet.</h2>
                      <p>Don't forget to enrol into units when the next enrolment period is open!</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default EnrolmentsContainer
